import React from 'react';
import Discount from '../../../controls/frame/Discount';
import Quantity from '../../../controls/frame/Quantity';

export const getDiscountsSection = (props) => {
  const {
    isDisabled,
    discountValue, setDiscountValue,
    quantityValue, setQuantityValue,
    ctrl_discount_enabled,
  } = props;

  return [
    // discount section starts ...

    // ✅ Conditionally add Discount only if enabled
    ...(ctrl_discount_enabled === 1
      ? [
          {
            id: "Discount",
            component: (
              <Discount
                disabled={isDisabled}
                label="Discount %"
                value={discountValue}
                onChange={(newValue) => setDiscountValue(newValue)}
              />
            ),
            position: [1, 1],
            status: "active",
            expandableSectionId: "Discounts",
          },
        ]
      : []),



    { id: "Quantity",    component: <Quantity
      disabled={isDisabled}
      value={quantityValue} // ✅ Pass current state value
      onChange={(newValue) =>
      { setQuantityValue(newValue); }
}/>, position: [1, 1], status: "active", expandableSectionId: "Discounts" },
    //discount ends...
  ];
};
